import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import ProfileImage from "../images/nathancolesjr.png";

const ownedCards = [
  // Replace these stand-in clips with actual BTS / on-set / editing vertical clips when available.
  {
    title: "Concept",
    subtext: "Ideas, story-telling, structure.",
    body: "I build the idea, hook, structure, and visual direction before the shoot.",
    mediaUrl: "/media/director/nathancolesjr_concept_4x5.mp4",
  },
  {
    title: "On set",
    subtext: "Talent, crew, decisions.",
    body: "I communicate with talent and collaborators to keep the video moving.",
    mediaUrl: "/media/director/nathancolesjr_onset_4x5.mp4",
  },
  {
    title: "Post",
    subtext: "Pacing, sound, VFX.",
    body: "I shape the final story through pacing, sound, effects, and edit decisions.",
    mediaUrl: "/media/director/nathancolesjr_post_4x5.mp4",
  },
  {
    title: "Release",
    subtext: "Titles, clips, retention.",
    body: "I think about how the video becomes clips, posts, moments, and marketing.",
    mediaUrl: "/media/director/nathancolesjr_release_4x5.mp4",
  },
];

const showDirectorReel = false;

const caseStudies = [
  {
    title: "g3urin & zvch - SWAG",
    role: "Director / Editor / Writer / Concept / VFX",
    goal: "Create a video that felt bigger than a standard performance visual.",
    what: "Built the concept, directed the shoot, shaped the edit, and used post-production to create the final world.",
    why: "The video gave the artist a stronger visual identity and created moments that could live beyond the full video.",
    reelId: "eSUXcPoFfFk",
  },
  {
    title: "JALLEN - Close2Me",
    role: "Director / Editor / Writer / Concept / VFX",
    goal: "Make the song feel intimate and cinematic without losing momentum.",
    what: "Built the concept, directed the performance and coverage, and shaped the edit around mood, pacing, and visual identity.",
    why: "The final piece gave the artist a stronger visual world and moments that could carry beyond the full release.",
    reelId: "lPmL8z8Gvtg",
  },
  {
    title: "g3urin - STACKDATMONEY (feat. zvch)",
    role: "Director / Editor / Writer / Concept / VFX",
    goal: "Create a video with stronger world-building than a standard performance cut.",
    what: "Directed the shoot, built the coverage around key moments, and shaped the edit to make the visual feel bigger and more intentional.",
    why: "The video gave the release a clearer identity and more memorable visual moments to carry the song online.",
    reelId: "khfa2qF-OhU",
  },
  {
    title: "Larry King's Valentines Short Film",
    role: "Director / Editor / Writer / Concept",
    goal: "Expand an already established short-film world and turn it into a branded piece that felt more serious than a typical creator upload.",
    what: "Used the existing lore from Larry King's short-film content, built a new concept around it, directed the shoot, and shaped the final piece to feel like a real short film rather than a one-off post.",
    why: "It helped expand his brand, made the content feel more intentional, and positioned him as a creator with a stronger narrative world around his work.",
    reelId: "WYf13Cjsn_U",
  },
];

const resultStats = [
  {
    value: "0-20,000",
    supporting: "Followers in 2 months",
    featured: true,
  },
  {
    value: "1,000+",
    supporting: "Short-form posts",
  },
  {
    value: "50K-2M",
    supporting: "Views every 30 days",
  },
  {
    value: "Millions",
    supporting: "Views generated across short-form content",
  },
];

function DirectorPage() {
  return (
    <main className="pageMain directorPage">
      <section className="section directorHero">
        <div className="directorHero__content">
          <div className="directorHero__portraitWrap" aria-hidden="true">
            <div className="directorHero__portraitGlow" />
            <img className="directorHero__portrait" src={ProfileImage} alt="" />
          </div>
          <h1>I direct videos from idea to final cut.</h1>
          <p>
            I write concepts, direct shoots, shape the edit, and design videos to move online after release.
          </p>
          <div className="directorHero__actions">
            {showDirectorReel ? (
              <a className="button button--secondary" href="#director-reel">
                Watch Reel
              </a>
            ) : null}
            <a className="button button--primary directorHero__workButton" href="#director-work">
              View Work
            </a>
          </div>
        </div>

        <div className="directorHero__visualGrid" aria-hidden="true">
          {ownedCards.map((card) => (
            <DirectorLoopTile key={card.title} mediaUrl={card.mediaUrl} label={card.title} subtext={card.subtext} />
          ))}
        </div>
      </section>

      {showDirectorReel ? (
        <section className="section directorSection" id="director-reel">
          <div className="sectionHeading">
            <h2>Director Reel</h2>
            <p>Concept, direction, editing, VFX, and internet-first storytelling.</p>
          </div>

          <div className="directorReelCard">
            <LiteYouTubeEmbed id="j2EI0QqPM9o" title="Nathan Coles Jr. Director Reel" />
          </div>
        </section>
      ) : null}

      {false ? (
        <section className="section directorSection">
          <div className="sectionHeading">
            <h2>What I do</h2>
          </div>

          <div className="directorOwnershipGrid">
            {ownedCards.map((card) => (
              <DirectorOwnershipCard key={card.title} card={card} />
            ))}
          </div>
        </section>
      ) : null}

      <section className="section directorSection" id="director-work">
        <div className="sectionHeading">
          <h2>Selected work</h2>
        </div>

        <div className="directorCaseStudyGrid">
          {caseStudies.map((study) => (
            <DirectorCaseStudy key={study.title} study={study} />
          ))}
        </div>
      </section>

      <section className="section directorSection">
        <div className="sectionHeading">
          <h2>Built for real production.</h2>
          <p>
            Shoots change. Locations are limited. Time runs out. I&apos;m used to making creative decisions in
            the moment and protecting the final video.
          </p>
        </div>
      </section>

      <section className="section directorSection">
        <div className="sectionHeading">
          <h2>I don&apos;t stop at the export.</h2>
          <p>
            I design videos with the rollout in mind, including the full piece, the clips, the hooks, and the moments
            people remember. After posting, I make sure that we capture all the information we need over the next couple 
            of weeks or months to make sure our next piece of content performs even better and we learn the right 
            things from each release.
          </p>
        </div>

        <div className="directorResultsGrid">
          {resultStats.map((stat) => (
            <article
              key={stat.supporting}
              className={`businessStatCard${stat.featured ? " businessStatCard--featured" : ""}`}
            >
              <span className="businessStatCard__value">{stat.value}</span>
              <span className="businessStatCard__supporting">{stat.supporting}</span>
            </article>
          ))}
        </div>
      </section>

      <section className="section businessCta directorCta">
        <div className="businessCta__card">
          <h2>Looking for a director who can think through the whole video?</h2>
          <p>
            I can help shape the idea, direct the shoot, build the edit, and think through how the final
            piece performs online.
          </p>
          <div className="businessCta__actions">
            <a className="button button--primary" href="mailto:nathancolesjr@gmail.com">
              Contact Nathan
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}

function DirectorLoopTile({ mediaUrl, label, subtext }) {
  return (
    <div className="directorLoopTile">
      {mediaUrl ? (
        <video className="directorLoopTile__video" autoPlay muted loop playsInline preload="metadata">
          <source src={mediaUrl} />
        </video>
      ) : null}
      <div className="directorLoopTile__overlay">
        <span>{label}</span>
        {subtext ? <small>{subtext}</small> : null}
      </div>
    </div>
  );
}

function DirectorOwnershipCard({ card }) {
  return (
    <article className="directorOwnershipCard">
      <DirectorLoopTile mediaUrl={card.mediaUrl} label={card.title} />
      <div className="directorOwnershipCard__copy">
        <h3>{card.title}</h3>
        <p>{card.body}</p>
      </div>
    </article>
  );
}

function DirectorCaseStudy({ study }) {
  return (
    <article className="directorCaseStudy">
      <div className="directorCaseStudy__media">
        <LiteYouTubeEmbed id={study.reelId} title={study.title} />
      </div>
      <div className="directorCaseStudy__copy">
        <h3>{study.title}</h3>
        <p className="directorCaseStudy__role">Role: {study.role}</p>
        <p>
          <strong>Goal:</strong> {study.goal}
        </p>
        <p>
          <strong>What I did:</strong> {study.what}
        </p>
        <p>
          <strong>Why it worked:</strong> {study.why}
        </p>
      </div>
    </article>
  );
}

export default DirectorPage;
